require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-our-new-mobile-app-development-curriculum-includes-android.json") })
        }
      }, "path---blog-our-new-mobile-app-development-curriculum-includes-android");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-our-new-mobile-app-development-curriculum-includes-android!./.cache/json/blog-our-new-mobile-app-development-curriculum-includes-android.json
// module id = 1024
// module chunks = 231608221292675